<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("calculators_common.customize") }}
    </h4>

    <div class="justify-start exptra_options picker_option_container flex-wrap">
      <div
        class="d-flex-column justify-start align-start gap-0"
        v-for="packOption in packOptions"
        :key="packOption"
      >
        <div
          class="picker_option d-flex-column space-between gap-16 align-start"
          :class="[isOptionSelected(packOption.id) && 'selected']"
          @click="() => selectOption(packOption)"
        >
          <div class="d-flex-row justify-start gap-5">
            <p class="t-white medium-l font-family-2">
              {{ packOption.title }}
            </p>
            <Tooltip
              :text="packOption.description"
              :position="'top'"
              v-if="!$isMobile()"
            >
              <poi-icon />
            </Tooltip>

            <h4 class="font-family-1 caps bold-s t-blue" v-if="$isMobile()">
              {{ renderPrice(packOption) }}
            </h4>
          </div>
          <div class="d-flex-row space-between" v-if="!$isMobile()">
            <h4 class="price_container font-family-1 caps bold-s t-blue">
              {{ renderPrice(packOption) }}
            </h4>
            <Switch
              :checked="isOptionSelected(packOption.id)"
              :click-events="switchClick"
              :click-param="packOption"
            />
          </div>
        </div>
        <Transition name="slide-fade-small">
          <p
            v-if="$isMobile() && isOptionSelected(packOption.id)"
            class="font-family-2 regular-m t-light-orange mobile_info_description"
          >
            {{
              packOption.title?.includes("new_text")
                ? $t(`${packOption.title}_desc`)
                : packOption.description
            }}
          </p>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
import PoiIcon from "../../../icons/PoiIcon.vue";
import Switch from "../../../custom/Switch.vue";
import Tooltip from "../../../custom/Tooltip.vue";
export default {
  data() {
    return {};
  },
  computed: {
    packOptions() {
      return (
        this.getGamePack.pack_options?.filter(
          (packOp) => packOp?.const_title !== "self_play"
        ) || []
      );
    },

    oneTrickOption() {
      return this.packOptions?.find(
        (op) => op.const_title === "one_trick_pony"
      );
    },
  },
  components: {
    PoiIcon,
    Switch,
    Tooltip,
  },
  methods: {
    renderPrice(packOption) {
      if (packOption.type === "free") {
        return packOption.type;
      } else if (packOption.type === "variable") {
        return `+${packOption.price}%`;
      } else if (packOption.type === "fixed") {
        return `+${packOption.price}$`;
      } else {
        return `+${packOption.price}`;
      }
    },
    isOptionSelected(packOption) {
      const selectedOption = this.checkoutStore.getPackOptions.find(
        (option) => option === packOption
      );
      if (!selectedOption) {
        return false;
      }
      return true;
    },

    selectOption(option) {
      if (!this.isOptionSelected(option.id)) {
        this.checkoutStore.removePackOption({
          optionIds: option?.rules?.disable || [],
        });
        let assign = [];
        if (option.rules?.assign) {
          assign = [option.rules.assign[0]];
        }

        this.checkoutStore.setPackOptions({
          options: [...this.checkoutStore.getPackOptions, option.id, ...assign],
        });
      } else {
        let otherOptions = this.checkoutStore.getPackOptions.filter(
          (packOpt) => packOpt !== option.id
        );
        if (option?.const_title === "preferred_heroes") {
          if (this.oneTrickOption) {
            otherOptions = otherOptions?.filter(
              (op) => op !== this.oneTrickOption?.id
            );
          }
        }

        this.checkoutStore.setPackOptions({
          options: [...otherOptions],
        });
      }
    },
  },
  setup() {
    const { getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGamePack,
      checkoutStore,
    };
  },
};
</script>
